import React, { useState, useEffect } from 'react';
import { newsletterAPI } from '../../utils/api';
import '../../styles/AdminTable.scss';

const AdminNewsletter = () => {
  const [subscribers, setSubscribers] = useState([]);
  const [stats, setStats] = useState({
    total: 0,
    confirmed: 0,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [skip, setSkip] = useState(0);
  const [limit] = useState(15);

  useEffect(() => {
    fetchSubscribers();
  }, [skip]);

  const fetchSubscribers = async () => {
    try {
      setLoading(true);
      setError('');
      const response = await newsletterAPI.getSubscribers(skip, limit);
      
      // axios wraps response in .data property
      const responseData = response.data || response;
      console.log('API Response:', responseData);
      
      // Handle response data structure
      const subscribersData = responseData.data?.subscribers || responseData.subscribers || [];
      const totalCount = responseData.data?.total || responseData.total || 0;
      const activeCount = responseData.data?.active || responseData.active || totalCount;
      
      setSubscribers(subscribersData);
      setStats({
        total: totalCount,
        confirmed: activeCount,
      });
      
      console.log('Loaded subscribers:', subscribersData.length);
    } catch (err) {
      setError(`Failed to load subscribers: ${err.message}`);
      console.error('Error fetching subscribers:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleUnsubscribe = async (email) => {
    if (window.confirm(`Unsubscribe ${email}?`)) {
      try {
        await newsletterAPI.unsubscribe(email);
        setSubscribers(subscribers.filter(s => s.email !== email));
        setStats({
          ...stats,
          confirmed: Math.max(0, stats.confirmed - 1),
        });
      } catch (err) {
        setError('Failed to unsubscribe');
        console.error('Error:', err);
      }
    }
  };

  const StatsCard = ({ title, value, icon, color }) => (
    <div className={`stat-card ${color}`}>
      <div className="stat-icon">{icon}</div>
      <div className="stat-content">
        <h3>{title}</h3>
        <p className="stat-value">{value}</p>
      </div>
    </div>
  );

  return (
    <div className="admin-page">
        <div className="page-header">
          <h1>Newsletter Subscribers</h1>
          <p>Manage newsletter subscriptions</p>
        </div>

        {error && <div className="error-message">{error}</div>}

        <div className="stats-grid">
          <StatsCard
            title="Total Subscribers"
            value={stats.total}
            icon="📊"
            color="blue"
          />
          <StatsCard
            title="Active"
            value={stats.confirmed}
            icon="✓"
            color="green"
          />
        </div>

        <div className="content-wrapper">
          <div className="table-container">
            {loading ? (
              <p>Loading...</p>
            ) : subscribers.length === 0 ? (
              <p>No subscribers</p>
            ) : (
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Email</th>
                    <th>Status</th>
                    <th>Subscribed Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {subscribers.map((subscriber) => (
                    <tr key={subscriber.id}>
                      <td>{subscriber.email}</td>
                      <td>
                        <span 
                          className="badge"
                          style={{
                            backgroundColor: subscriber.is_active ? '#228B22' : '#DC143C',
                            color: 'white',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '12px'
                          }}
                        >
                          {subscriber.is_active ? 'Active' : 'Inactive'}
                        </span>
                      </td>
                      <td>
                        {new Date(subscriber.created_at).toLocaleDateString()}
                      </td>
                      <td className="actions">
                        <button
                          className="btn-delete"
                          onClick={() => handleUnsubscribe(subscriber.email)}
                          title="Unsubscribe"
                        >
                          🚫
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>

        <div className="pagination">
          <button 
            disabled={skip === 0} 
            onClick={() => setSkip(Math.max(0, skip - limit))}
          >
            Previous
          </button>
          <span>Page {Math.floor(skip / limit) + 1} (Total: {stats.total})</span>
          <button 
            disabled={skip + limit >= stats.total || stats.total === 0}
            onClick={() => setSkip(skip + limit)}
          >
            Next
          </button>
        </div>
      </div>
  );
};

export default AdminNewsletter;
